<aside
  class="h-screen bg-side-navigation-panel-default-bg border-r border-side-navigation-panel-default-border flex flex-col fixed left-0 top-0 z-60 transition-all duration-200 ease-in-out select-none overflow-x-hidden"
  [class.sidebar-expanded-w]="!layoutService.isSidebarCollapsed()"
  [class.sidebar-collapsed-w]="layoutService.isSidebarCollapsed()"
>
  <!-- TOP HEADER -->
  <div
    class="h-16 shrink-0 flex items-center border-b border-side-navigation-panel-default-border/50 px-3 justify-between overflow-hidden"
  >
    <a
      routerLink="/"
      class="text-text-primary font-extrabold text-xl tracking-wider hover:opacity-90 transition-all duration-200 overflow-hidden whitespace-nowrap"
      [class.opacity-100]="!layoutService.isSidebarCollapsed()"
      [class.opacity-0]="layoutService.isSidebarCollapsed()"
      [class.max-w-xs]="!layoutService.isSidebarCollapsed()"
      [class.max-w-0]="layoutService.isSidebarCollapsed()"
      [class.pointer-events-none]="layoutService.isSidebarCollapsed()"
      [class.pl-1]="!layoutService.isSidebarCollapsed()"
      aria-label="HypeTrack home"
    >
      HYPETRACK
    </a>
    <button
      type="button"
      (click)="layoutService.toggleSidebarCollapse()"
      class="w-10 h-10 flex items-center justify-center rounded-full text-text-half-dimmed hover:text-text-primary hover:bg-side-navigation-item-hover-bg transition-colors cursor-pointer shrink-0"
      [title]="layoutService.isSidebarCollapsed() ? 'Expand sidebar' : 'Collapse sidebar'"
    >
      <svg
        width="22"
        height="18"
        viewBox="0 0 22 18"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M21.4615 3.46154C21.4615 1.55423 19.9073 0 18 0H3.46154C1.55423 0 0 1.55423 0 3.46154V14.5385C0 16.4458 1.55423 18 3.46154 18H18C19.9073 18 21.4615 16.4458 21.4615 14.5385V3.46154ZM6.92308 15.9231H3.46154C2.69654 15.9231 2.07692 15.3035 2.07692 14.5385V3.46154C2.07692 2.69654 2.69654 2.07692 3.46154 2.07692H6.92308V15.9231ZM19.3846 14.5385C19.3846 15.3035 18.765 15.9231 18 15.9231H9V2.07692H18C18.765 2.07692 19.3846 2.69654 19.3846 3.46154V14.5385Z"
        />
      </svg>
    </button>
  </div>

  <!-- NAVIGATION BODY -->
  <nav class="flex-1 overflow-y-auto overflow-x-hidden custom-scrollbar p-3 space-y-1">
    <!-- EXPLORE SECTION -->
    <div class="h-9 flex items-center relative overflow-hidden my-1">
      <span
        class="text-[13px] font-medium text-text-dimmed px-3 whitespace-nowrap transition-all duration-200"
        [class.opacity-100]="!layoutService.isSidebarCollapsed()"
        [class.opacity-0]="layoutService.isSidebarCollapsed()"
      >
        Explore
      </span>
      <div
        class="absolute inset-0 flex items-center justify-center pointer-events-none transition-all duration-200"
        [class.opacity-0]="!layoutService.isSidebarCollapsed()"
        [class.opacity-100]="layoutService.isSidebarCollapsed()"
      >
        <div class="border-t border-card-border-border w-6"></div>
      </div>
    </div>

    <!-- Artists -->
    <a
      routerLink="/overview/artists"
      (click)="onOverviewClick()"
      routerLinkActive="bg-side-navigation-item-active-bg !text-text-primary"
      [attr.title]="layoutService.isSidebarCollapsed() ? 'Artists' : null"
      class="flex items-center gap-3 h-10 rounded-full text-text-half-dimmed hover:bg-side-navigation-item-hover-bg hover:text-text-half-dimmed transition-all duration-200 cursor-pointer group font-medium text-sm overflow-hidden w-full"
    >
      <div class="w-10 h-10 flex items-center justify-center shrink-0">
        <svg
          width="18"
          height="18"
          viewBox="0 0 20 21"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4.2375 6.9375C3.885 7.29 3.315 7.29 2.96625 6.9375L0.5625 4.5375C0.21375 4.185 0.21375 3.615 0.5625 3.2625C0.91125 2.91 1.485 2.91375 1.8375 3.2625L2.7 4.12875V0.9C2.7 0.40125 3.10125 0 3.6 0C4.09875 0 4.5 0.40125 4.5 0.9V4.12875L5.3625 3.26625C5.715 2.91375 6.285 2.91375 6.63375 3.26625C6.9825 3.61875 6.98625 4.18875 6.63375 4.5375L4.23375 6.9375H4.2375ZM16.2375 6.9375C15.885 7.29 15.315 7.29 14.9662 6.9375L12.5625 4.5375C12.21 4.185 12.21 3.615 12.5625 3.26625C12.915 2.9175 13.485 2.91375 13.8337 3.26625L14.6962 4.12875V0.9C14.6962 0.40125 15.0975 0 15.5962 0C16.095 0 16.4962 0.40125 16.4962 0.9V4.12875L17.3587 3.26625C17.7112 2.91375 18.2812 2.91375 18.63 3.26625C18.9787 3.61875 18.9825 4.18875 18.63 4.5375L16.23 6.9375H16.2375ZM9.6 8.4C10.7587 8.4 11.7 9.34125 11.7 10.5C11.7 11.6587 10.7587 12.6 9.6 12.6C8.44125 12.6 7.5 11.6587 7.5 10.5C7.5 9.34125 8.44125 8.4 9.6 8.4ZM9.6 14.4C11.5875 14.4 13.2 16.0125 13.2 18V19.2C13.2 19.8637 12.6637 20.4 12 20.4H7.2C6.53625 20.4 6 19.8637 6 19.2V18C6 16.0125 7.6125 14.4 9.6 14.4ZM1.2 12C1.2 11.0062 2.00625 10.2 3 10.2C3.99375 10.2 4.8 11.0062 4.8 12C4.8 12.9937 3.99375 13.8 3 13.8C2.00625 13.8 1.2 12.9937 1.2 12ZM14.4 12C14.4 11.0062 15.2062 10.2 16.2 10.2C17.1937 10.2 18 11.0062 18 12C18 12.9937 17.1937 13.8 16.2 13.8C15.2062 13.8 14.4 12.9937 14.4 12ZM3 15C3.57375 15 4.11 15.1612 4.5675 15.4425C4.33125 16.05 4.2 16.71 4.2 17.4V19.2C4.2 19.6275 4.29 20.0325 4.45125 20.4H1.15875C0.5175 20.4 0 19.8825 0 19.2412V18C0 16.3425 1.3425 15 3 15ZM14.7487 20.4C14.91 20.0325 15 19.6275 15 19.2V17.4C15 16.71 14.8687 16.05 14.6325 15.4425C15.09 15.1612 15.6262 15 16.2 15C17.8575 15 19.2 16.3425 19.2 18V19.2412C19.2 19.8787 18.6825 20.4 18.0412 20.4H14.7487Z"
          />
        </svg>
      </div>
      <span
        class="truncate pr-4 whitespace-nowrap transition-all duration-200"
        [class.opacity-100]="!layoutService.isSidebarCollapsed()"
        [class.opacity-0]="layoutService.isSidebarCollapsed()"
      >
        Artists
      </span>
    </a>

    <!-- Labels -->
    <a
      routerLink="/overview/labels"
      routerLinkActive="bg-side-navigation-item-active-bg !text-text-primary"
      [attr.title]="layoutService.isSidebarCollapsed() ? 'Labels' : null"
      class="flex items-center gap-3 h-10 rounded-full text-text-half-dimmed hover:bg-side-navigation-item-hover-bg hover:text-text-half-dimmed transition-all duration-200 cursor-pointer group font-medium text-sm overflow-hidden w-full"
    >
      <div class="w-10 h-10 flex items-center justify-center shrink-0">
        <svg
          width="18"
          height="18"
          viewBox="0 0 15 20"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2.4 0C1.07625 0 0 1.07625 0 2.4V16.8C0 18.1237 1.07625 19.2 2.4 19.2H12C13.3237 19.2 14.4 18.1237 14.4 16.8V2.4C14.4 1.07625 13.3237 0 12 0H2.4ZM6.6 13.2H7.8C8.46375 13.2 9 13.7362 9 14.4V17.4H5.4V14.4C5.4 13.7362 5.93625 13.2 6.6 13.2ZM3.6 4.2C3.6 3.87 3.87 3.6 4.2 3.6H5.4C5.73 3.6 6 3.87 6 4.2V5.4C6 5.73 5.73 6 5.4 6H4.2C3.87 6 3.6 5.73 3.6 5.4V4.2ZM9 3.6H10.2C10.53 3.6 10.8 3.87 10.8 4.2V5.4C10.8 5.73 10.53 6 10.2 6H9C8.67 6 8.4 5.73 8.4 5.4V4.2C8.4 3.87 8.67 3.6 9 3.6ZM3.6 9C3.6 8.67 3.87 8.4 4.2 8.4H5.4C5.73 8.4 6 8.67 6 9V10.2C6 10.53 5.73 10.8 5.4 10.8H4.2C3.87 10.8 3.6 10.53 3.6 10.2V9ZM9 8.4H10.2C10.53 8.4 10.8 8.67 10.8 9V10.2C10.8 10.53 10.53 10.8 10.2 10.8H9C8.67 10.8 8.4 10.53 8.4 10.2V9C8.4 8.67 8.67 8.4 9 8.4Z"
          />
        </svg>
      </div>
      <span
        class="truncate pr-4 whitespace-nowrap transition-all duration-200"
        [class.opacity-100]="!layoutService.isSidebarCollapsed()"
        [class.opacity-0]="layoutService.isSidebarCollapsed()"
      >
        Labels
      </span>
    </a>

    <!-- Brands -->
    <a
      routerLink="/overview/brands"
      routerLinkActive="bg-side-navigation-item-active-bg !text-text-primary"
      [attr.title]="layoutService.isSidebarCollapsed() ? 'Brands' : null"
      class="flex items-center gap-3 h-10 rounded-full text-text-half-dimmed hover:bg-side-navigation-item-hover-bg hover:text-text-half-dimmed transition-all duration-200 cursor-pointer group font-medium text-sm overflow-hidden w-full"
    >
      <div class="w-10 h-10 flex items-center justify-center shrink-0">
        <svg
          width="18"
          height="18"
          viewBox="0 0 20 18"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.5 1.8H11.7C11.865 1.8 12 1.935 12 2.1V3.6H7.2V2.1C7.2 1.935 7.335 1.8 7.5 1.8ZM5.4 2.1V3.6H2.4C1.07625 3.6 0 4.67625 0 6V9.6H19.2V6C19.2 4.67625 18.1237 3.6 16.8 3.6H13.8V2.1C13.8 0.94125 12.8587 0 11.7 0H7.5C6.34125 0 5.4 0.94125 5.4 2.1ZM19.2 11.4H12V12C12 12.6638 11.4637 13.2 10.8 13.2H8.4C7.73625 13.2 7.2 12.6638 7.2 12V11.4H0V15.6C0 16.9238 1.07625 18 2.4 18H16.8C18.1237 18 19.2 16.9238 19.2 15.6V11.4Z"
          />
        </svg>
      </div>
      <span
        class="truncate pr-4 whitespace-nowrap transition-all duration-200"
        [class.opacity-100]="!layoutService.isSidebarCollapsed()"
        [class.opacity-0]="layoutService.isSidebarCollapsed()"
      >
        Brands
      </span>
    </a>

    <!-- CHARTS SECTION -->
    <div class="h-9 flex items-center relative overflow-hidden my-1">
      <span
        class="text-[13px] font-medium text-text-dimmed px-3 whitespace-nowrap transition-all duration-200"
        [class.opacity-100]="!layoutService.isSidebarCollapsed()"
        [class.opacity-0]="layoutService.isSidebarCollapsed()"
      >
        Charts
      </span>
      <div
        class="absolute inset-0 flex items-center justify-center pointer-events-none transition-all duration-200"
        [class.opacity-0]="!layoutService.isSidebarCollapsed()"
        [class.opacity-100]="layoutService.isSidebarCollapsed()"
      >
        <div class="border-t border-card-border-border w-6"></div>
      </div>
    </div>
    <a
      routerLink="/charts/ifpi"
      (click)="onChartsClick()"
      routerLinkActive="bg-side-navigation-item-active-bg !text-text-primary"
      [attr.title]="layoutService.isSidebarCollapsed() ? 'IFPI Chart' : null"
      class="flex items-center gap-3 h-10 rounded-full text-text-half-dimmed hover:bg-side-navigation-item-hover-bg hover:text-text-half-dimmed transition-all duration-200 cursor-pointer group font-medium text-sm overflow-hidden w-full"
    >
      <div class="w-10 h-10 flex items-center justify-center shrink-0">
        <svg
          width="18"
          height="18"
          viewBox="0 0 20 17"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2.4 1.2C2.4 0.53625 1.86375 0 1.2 0C0.53625 0 0 0.53625 0 1.2V13.8C0 15.4575 1.3425 16.8 3 16.8H18C18.6637 16.8 19.2 16.2637 19.2 15.6C19.2 14.9362 18.6637 14.4 18 14.4H3C2.67 14.4 2.4 14.13 2.4 13.8V1.2ZM17.6475 4.4475C18.1162 3.97875 18.1162 3.2175 17.6475 2.74875C17.1787 2.28 16.4175 2.28 15.9487 2.74875L12 6.70125L9.8475 4.5525C9.37875 4.08375 8.6175 4.08375 8.14875 4.5525L4.54875 8.1525C4.08 8.62125 4.08 9.3825 4.54875 9.85125C5.0175 10.32 5.77875 10.32 6.2475 9.85125L9 7.09875L11.1525 9.25125C11.6212 9.72 12.3825 9.72 12.8512 9.25125L17.6512 4.45125L17.6475 4.4475Z"
          />
        </svg>
      </div>
      <span
        class="truncate pr-4 whitespace-nowrap transition-all duration-200"
        [class.opacity-100]="!layoutService.isSidebarCollapsed()"
        [class.opacity-0]="layoutService.isSidebarCollapsed()"
      >
        IFPI Chart
      </span>
    </a>
    <!-- STREAMING CHARTS SECTION -->
    <div class="flex flex-col w-full">
      <button
        type="button"
        (click)="onStreamingClick()"
        [attr.title]="layoutService.isSidebarCollapsed() ? 'Streaming Charts' : null"
        class="flex items-center justify-between h-10 rounded-full text-text-half-dimmed hover:bg-side-navigation-item-hover-bg hover:text-text-primary transition-all duration-200 cursor-pointer group font-medium text-sm overflow-hidden w-full px-0"
        [class.bg-side-navigation-item-active-bg]="isStreamingRouteActive() && (!isStreamingOpen() || layoutService.isSidebarCollapsed())"
        [class.!text-text-primary]="isStreamingRouteActive() && (!isStreamingOpen() || layoutService.isSidebarCollapsed())"
      >
        <div class="flex items-center gap-3 truncate">
          <div class="w-10 h-10 flex items-center justify-center shrink-0">
            <svg
              data-dc-tpl="68"
              width="20"
              height="20"
              viewBox="0 0 512 512"
              fill="currentColor"
            >
              <path
                data-dc-tpl="69"
                d="M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM188.3 147.1c7.6-4.2 16.8-4.1 24.3 .5l144 88c7.1 4.4 11.5 12.1 11.5 20.5s-4.4 16.1-11.5 20.5l-144 88c-7.4 4.5-16.7 4.7-24.3 .5s-12.3-12.2-12.3-20.9l0-176c0-8.7 4.7-16.7 12.3-20.9z"
              />
            </svg>
          </div>

          <!-- Label -->
          <span
            class="truncate whitespace-nowrap transition-all duration-200"
            [class.opacity-100]="!layoutService.isSidebarCollapsed()"
            [class.opacity-0]="layoutService.isSidebarCollapsed()"
          >
            Streaming Charts
          </span>
        </div>

        <!-- Chevron Icon (Rotates when open) -->
        <div
          class="flex items-center justify-center shrink-0 transition-all duration-200"
          [class.pr-3]="!layoutService.isSidebarCollapsed()"
          [class.w-0]="layoutService.isSidebarCollapsed()"
          [class.p-0]="layoutService.isSidebarCollapsed()"
          [class.overflow-hidden]="layoutService.isSidebarCollapsed()"
          [class.opacity-100]="!layoutService.isSidebarCollapsed()"
          [class.opacity-0]="layoutService.isSidebarCollapsed()"
          [class.pointer-events-none]="layoutService.isSidebarCollapsed()"
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2.5"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="transition-transform duration-300"
            [class.rotate-180]="isStreamingOpen()"
          >
            <path d="M6 9l6 6 6-6" />
          </svg>
        </div>
      </button>

      <!-- Submenu Items Container (Billboard, Spotify, Shazam, Apple) -->
      <div
        class="overflow-hidden transition-all duration-300 ease-in-out flex flex-col space-y-1 w-full"
        [class.h-[176px]]="!layoutService.isSidebarCollapsed() && isStreamingOpen()"
        [class.pt-1]="!layoutService.isSidebarCollapsed() && isStreamingOpen()"
        [class.h-0]="layoutService.isSidebarCollapsed() || !isStreamingOpen()"
        [class.pt-0]="layoutService.isSidebarCollapsed() || !isStreamingOpen()"
        [class.opacity-100]="!layoutService.isSidebarCollapsed() && isStreamingOpen()"
        [class.opacity-0]="layoutService.isSidebarCollapsed() || !isStreamingOpen()"
        [class.pointer-events-auto]="!layoutService.isSidebarCollapsed() && isStreamingOpen()"
        [class.pointer-events-none]="layoutService.isSidebarCollapsed() || !isStreamingOpen()"
      >
        <!-- Billboard Charts -->
        <a
          routerLink="/charts/billboard"
          routerLinkActive="bg-side-navigation-item-active-bg !text-text-primary"
          class="flex items-center h-10 pl-[52px] pr-4 rounded-full text-text-half-dimmed hover:bg-side-navigation-item-hover-bg hover:text-text-primary transition-all duration-200 cursor-pointer font-medium text-sm overflow-hidden w-full whitespace-nowrap"
        >
          <span class="truncate">Billboard Charts</span>
        </a>

        <!-- Spotify Charts -->
        <a
          routerLink="/charts/spotify"
          routerLinkActive="bg-side-navigation-item-active-bg !text-text-primary"
          class="flex items-center h-10 pl-[52px] pr-4 rounded-full text-text-half-dimmed hover:bg-side-navigation-item-hover-bg hover:text-text-primary transition-all duration-200 cursor-pointer font-medium text-sm overflow-hidden w-full whitespace-nowrap"
        >
          <span class="truncate">Spotify Charts</span>
        </a>

        <!-- Shazam Charts -->
        <a
          routerLink="/charts/shazam"
          routerLinkActive="bg-side-navigation-item-active-bg !text-text-primary"
          class="flex items-center h-10 pl-[52px] pr-4 rounded-full text-text-half-dimmed hover:bg-side-navigation-item-hover-bg hover:text-text-primary transition-all duration-200 cursor-pointer font-medium text-sm overflow-hidden w-full whitespace-nowrap"
        >
          <span class="truncate">Shazam Charts</span>
        </a>

        <!-- Apple Charts -->
        <a
          routerLink="/charts/apple-music"
          routerLinkActive="bg-side-navigation-item-active-bg !text-text-primary"
          class="flex items-center h-10 pl-[52px] pr-4 rounded-full text-text-half-dimmed hover:bg-side-navigation-item-hover-bg hover:text-text-primary transition-all duration-200 cursor-pointer font-medium text-sm overflow-hidden w-full whitespace-nowrap"
        >
          <span class="truncate">Apple Charts</span>
        </a>
      </div>
    </div>
    <!-- Radio -->
    <a
      routerLink="/charts/radio"
      routerLinkActive="bg-side-navigation-item-active-bg !text-text-primary"
      [attr.title]="layoutService.isSidebarCollapsed() ? 'Radio' : null"
      class="flex items-center gap-3 h-10 rounded-full text-text-half-dimmed hover:bg-side-navigation-item-hover-bg hover:text-text-half-dimmed transition-all duration-200 cursor-pointer group font-medium text-sm overflow-hidden w-full"
    >
      <div class="w-10 h-10 flex items-center justify-center shrink-0">
        <svg
          width="18"
          height="18"
          viewBox="0 0 17 17"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0 1.2C0 0.53625 0.53625 0 1.2 0C9.8175 0 16.8 6.9825 16.8 15.6C16.8 16.2637 16.2637 16.8 15.6 16.8C14.9362 16.8 14.4 16.2637 14.4 15.6C14.4 8.31 8.49 2.4 1.2 2.4C0.53625 2.4 0 1.86375 0 1.2ZM0 14.4C0 13.0762 1.07625 12 2.4 12C3.72375 12 4.8 13.0762 4.8 14.4C4.8 15.7237 3.72375 16.8 2.4 16.8C1.07625 16.8 0 15.7237 0 14.4ZM1.2 4.8C7.16625 4.8 12 9.63375 12 15.6C12 16.2637 11.4637 16.8 10.8 16.8C10.1362 16.8 9.6 16.2637 9.6 15.6C9.6 10.9612 5.83875 7.2 1.2 7.2C0.53625 7.2 0 6.66375 0 6C0 5.33625 0.53625 4.8 1.2 4.8Z"
          />
        </svg>
      </div>
      <span
        class="truncate pr-4 whitespace-nowrap transition-all duration-200"
        [class.opacity-100]="!layoutService.isSidebarCollapsed()"
        [class.opacity-0]="layoutService.isSidebarCollapsed()"
      >
        Radio
      </span>
    </a>

    <!-- TRENDS SECTION -->
    <div class="h-9 flex items-center relative overflow-hidden my-1">
      <span
        class="text-[13px] font-medium text-text-dimmed px-3 whitespace-nowrap transition-all duration-200"
        [class.opacity-100]="!layoutService.isSidebarCollapsed()"
        [class.opacity-0]="layoutService.isSidebarCollapsed()"
      >
        Trends
      </span>
      <div
        class="absolute inset-0 flex items-center justify-center pointer-events-none transition-all duration-200"
        [class.opacity-0]="!layoutService.isSidebarCollapsed()"
        [class.opacity-100]="layoutService.isSidebarCollapsed()"
      >
        <div class="border-t border-card-border-border w-6"></div>
      </div>
    </div>

    <!-- Year in Review -->
    <a
      routerLink="/overview/year"
      routerLinkActive="bg-side-navigation-item-active-bg !text-text-primary"
      [attr.title]="layoutService.isSidebarCollapsed() ? 'Year in Review' : null"
      class="flex items-center gap-3 h-10 rounded-full text-text-half-dimmed hover:bg-side-navigation-item-hover-bg hover:text-text-half-dimmed transition-all duration-200 cursor-pointer group font-medium text-sm overflow-hidden w-full"
    >
      <div class="w-10 h-10 flex items-center justify-center shrink-0">
        <svg
          width="18"
          height="18"
          viewBox="0 0 17 18"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4.8 0C4.13625 0 3.6 0.53625 3.6 1.2V2.4H2.4C1.07625 2.4 0 3.47625 0 4.8V6.6H16.8V4.8C16.8 3.47625 15.7237 2.4 14.4 2.4H13.2V1.2C13.2 0.53625 12.6637 0 12 0C11.3362 0 10.8 0.53625 10.8 1.2V2.4H6V1.2C6 0.53625 5.46375 0 4.8 0ZM0 8.4V15.6C0 16.9238 1.07625 18 2.4 18H14.4C15.7237 18 16.8 16.9238 16.8 15.6V8.4H0Z"
          />
        </svg>
      </div>
      <span
        class="truncate pr-4 whitespace-nowrap transition-all duration-200"
        [class.opacity-100]="!layoutService.isSidebarCollapsed()"
        [class.opacity-0]="layoutService.isSidebarCollapsed()"
      >
        Year in Review
      </span>
    </a>

    <!-- ADMIN SECTION (IF APPLICABLE) -->
    @if (authService.isAdmin()) {
      <div class="h-9 flex items-center relative overflow-hidden my-1">
        <span
          class="text-[13px] font-medium text-text-dimmed px-3 whitespace-nowrap transition-all duration-200"
          [class.opacity-100]="!layoutService.isSidebarCollapsed()"
          [class.opacity-0]="layoutService.isSidebarCollapsed()"
        >
          Admin
        </span>
        <div
          class="absolute inset-0 flex items-center justify-center pointer-events-none transition-all duration-200"
          [class.opacity-0]="!layoutService.isSidebarCollapsed()"
          [class.opacity-100]="layoutService.isSidebarCollapsed()"
        >
          <div class="border-t border-card-border-border w-6"></div>
        </div>
      </div>

      <a
        routerLink="/admin"
        routerLinkActive="bg-side-navigation-item-active-bg !text-text-primary"
        [attr.title]="layoutService.isSidebarCollapsed() ? 'Admin Management' : null"
        class="flex items-center gap-3 h-10 rounded-full text-text-half-dimmed hover:bg-side-navigation-item-hover-bg hover:text-text-half-dimmed transition-all duration-200 cursor-pointer group font-medium text-sm overflow-hidden w-full"
      >
        <div class="w-10 h-10 flex items-center justify-center shrink-0">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <rect width="18" height="18" x="3" y="3" rx="2" />
            <path d="M3 9h18" />
            <path d="M9 21V9" />
          </svg>
        </div>
        <span
          class="truncate pr-4 whitespace-nowrap transition-all duration-200"
          [class.opacity-100]="!layoutService.isSidebarCollapsed()"
          [class.opacity-0]="layoutService.isSidebarCollapsed()"
        >
          Management
        </span>
      </a>
    }
  </nav>

  <!-- FOOTER / SIGN IN / PROFILE -->
  <div class="p-3 border-t border-side-navigation-panel-default-border/60 overflow-hidden">
    @if (authService.isAuthenticated()) {
      <div
        (click)="authService.logout()"
        [attr.title]="
          layoutService.isSidebarCollapsed()
            ? (authService.currentUser()?.username || 'User') + ' (Logout)'
            : 'Logout'
        "
        class="flex items-center gap-2.5 h-10 w-full rounded-md bg-side-navigation-item-default-bg hover:bg-side-navigation-item-hover-bg active:bg-side-navigation-item-active-bg transition-all duration-200 px-1 py-1 cursor-pointer overflow-hidden group"
      >
        <div class="w-8 h-8 flex items-center justify-center shrink-0">
          <div
            class="w-7 h-7 rounded-full bg-button-primary-default text-button-inverted-primary-default flex items-center justify-center font-bold text-xs shrink-0 shadow-xs overflow-hidden"
          >
            {{ authService.currentUser()?.username?.charAt(0)?.toUpperCase() || 'U' }}
          </div>
        </div>
        <div
          class="flex flex-col min-w-0 pr-1 whitespace-nowrap transition-all duration-200 overflow-hidden"
          [class.opacity-100]="!layoutService.isSidebarCollapsed()"
          [class.opacity-0]="layoutService.isSidebarCollapsed()"
          [class.max-w-xs]="!layoutService.isSidebarCollapsed()"
          [class.max-w-0]="layoutService.isSidebarCollapsed()"
        >
          <span class="text-sm font-semibold text-text-primary truncate leading-tight">
            {{ authService.currentUser()?.username || 'User Name' }}
          </span>
          <span class="text-xs font-normal text-text-dimmed truncate leading-tight">
            {{ authService.isAdmin() ? 'Admin' : 'User Role' }}
          </span>
        </div>
      </div>
    } @else {
      <a
        routerLink="/login"
        [attr.title]="layoutService.isSidebarCollapsed() ? 'Sign In' : null"
        class="flex items-center justify-center h-10 w-full rounded-md bg-button-primary-default text-button-inverted-primary-default font-semibold text-sm hover:bg-button-primary-hover transition-all duration-200 shadow-sm overflow-hidden cursor-pointer"
        [class.gap-2]="!layoutService.isSidebarCollapsed()"
        [class.gap-0]="layoutService.isSidebarCollapsed()"
      >
        <span
          class="whitespace-nowrap transition-all duration-200 overflow-hidden"
          [class.opacity-100]="!layoutService.isSidebarCollapsed()"
          [class.opacity-0]="layoutService.isSidebarCollapsed()"
          [class.max-w-xs]="!layoutService.isSidebarCollapsed()"
          [class.max-w-0]="layoutService.isSidebarCollapsed()"
        >
          Sign In
        </span>
        <svg
          width="15"
          height="11"
          viewBox="0 0 15 11"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
          class="shrink-0"
        >
          <path
            d="M14.1356 6.03773C14.4872 5.68617 14.4872 5.11523 14.1356 4.76367L9.63562 0.263672C9.28406 -0.0878906 8.71312 -0.0878906 8.36156 0.263672C8.01 0.615234 8.01 1.18617 8.36156 1.53773L11.3259 4.50211H0.9C0.402187 4.50211 0 4.9043 0 5.40211C0 5.89992 0.402187 6.30211 0.9 6.30211H11.3259L8.36156 9.26648C8.01 9.61805 8.01 10.189 8.36156 10.5405C8.71312 10.8921 9.28406 10.8921 9.63562 10.5405L14.1356 6.04055V6.03773Z"
          />
        </svg>
      </a>
    }
  </div>
</aside>
